export default "__VITE_ASSET__b140028a__"